import { render, staticRenderFns } from "./configs.vue?vue&type=template&id=1010d7f2&scoped=true&"
import script from "./configs.vue?vue&type=script&lang=js&"
export * from "./configs.vue?vue&type=script&lang=js&"
import style0 from "./configs.vue?vue&type=style&index=0&id=1010d7f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1010d7f2",
  null
  
)

export default component.exports